module.exports = require('./lib/messageformat').default;
